/* Utility component for adding buttons with touch-events attached to it.
 * Component prevents ghost clicks, and adds an 'ope-pressed' class to the element
 * on 'touchstart'.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Tappable from 'react-tappable/lib/Tappable';
import createReactClass from 'create-react-class'


var TouchButton = createReactClass({

	componentDidMount: function() {
		var TouchButton = ReactDOM.findDOMNode(this);
		// Prevent default on touchend to prevent 'Ghost-click' on touchdevices
		// Note that this BREAKS onClick on touch-devices, so make sure to use this component
		// or OpeTouchLink to add buttons or links to the application
		// For more info about 'Ghost clicks' see: http://ariatemplates.com/blog/2014/05/ghost-clicks-in-mobile-browsers/
		TouchButton.addEventListener('touchend', function(event) {
			event.preventDefault();
			// And remove ope-button--pressed
			var c = event.target.className;
			event.target.className = c.replace(new RegExp("(?:^|\\s+)" + "ope-button--pressed" + "(?:\\s+|$)", "g"), "");
		});

		// Add a ope-pressed class to the elements className on touchstart
		TouchButton.addEventListener('touchstart', function(event) {
			event.target.className += ' ope-button--pressed ';
		});
	},

	render: function() {
		var className = this.props.className;
		return (
			<Tappable onTap={this.props.onTap}>
				<span className={className} id={this.props.id}>
					{this.props.children}
				</span>
			</Tappable>
		);
	}
});

export default TouchButton;
